<div class="flex min-h-screen flex-col bg-white">
<app-header [homeRoute]="homeRoute"></app-header>

  <main class="flex-1">
    <router-outlet></router-outlet>
  </main>

  <app-footer></app-footer>
</div>
